<script setup>
// icons
import Incoming from "@/components/Icons/Telephony/Incoming.vue";
import MissedCalls from "@/components/Icons/Telephony/MissedCalls.vue";
import Outgoing from "@/components/Icons/Telephony/Outgoing.vue";
import TotalCalls from "@/components/Icons/Telephony/TotalCalls.vue";
import Unanswered from "@/components/Icons/Telephony/Unanswered.vue";


const props = defineProps({
    loading: {
        type: Boolean,
        default: false
    },
    card: {
        type: Object,
        default: () => ({})
    }
})

const iconsMap = {
    incoming_calls: Incoming,
    outgoing_calls: Outgoing,
    total_calls: TotalCalls,
    unanswered_outgoing_calls: Unanswered,
    missed_incoming_calls: MissedCalls
}
</script>

<template>
    <div class="s-card">
        <div class="s-card__icon">
            <component :is="iconsMap[card.key]"/>
        </div>

        <div class="s-card__info">
            <div v-if="loading" class="spinner"></div>
            <p v-else class="s-card__count">{{ props.card?.count || 0 }}</p>

            <p class="s-card__description">{{ props.card?.description || 'Description' }}</p>
        </div>
    </div>
</template>

<style scoped lang="scss">
.s-card {
    flex: 1;
    padding: 10px;
    border-radius: 11px;
    background: linear-gradient(180deg, rgba(122, 112, 223, 0.15) 0%, rgba(242, 242, 242, 0.00) 100%);

    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 15px;

    &__icon {
        padding: 12px;
        border-radius: 9px;
        background: #FFF;
        box-shadow: 0 10px 13px 0 rgba(122, 112, 223, 0.22);

        svg {
            width: 32px;
            height: 32px;
        }
    }

    &__info {
        flex: 1;
        display: flex;
        flex-direction: column;
    }

    &__count,
    .spinner {
        margin-bottom: 4px;
    }

    &__count {
        color: #7A70DF;
        font-family: "Gilroy", sans-serif;
        font-size: 32px;
        font-style: normal;
        font-weight: 600;
        line-height: 32px;
        text-transform: uppercase;
    }

    &__description {
        color: #000;
        font-family: "Gilroy", sans-serif;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
    }
}

// level with the 32px count it stands in for
.spinner {
    height: 32px;
    width: 32px;
    margin-left: 0;
    margin-right: 0;
    border-width: 4px;
}

@media screen and (max-width: 1024px) {
    .s-card {
        flex: 0 0 calc(50% - 16px);
    }
}

@media screen and (max-width: 640px) {
    .s-card {
        flex: 0 0 100%;
    }
}
</style>
